document.addEventListener('DOMContentLoaded', function() {
    // Find the 'a' element with href of '#reamaze-widget'
    var reamazeLink = document.querySelector('a[href="#reamaze-widget"]');

    // Attach click event listener to the found 'a' element
    reamazeLink.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default behavior of the link

        // Find the nested div with the id 'nested-reamaze-popup' inside the div with id 'reamaze-container'
        var reamazeContainer = document.getElementById('reamaze-container');
        var nestedReamazePopup = reamazeContainer.getElementById('reamaze-popup');

        // Add the class 'reamaze-visible' to the found element
        nestedReamazePopup.classList.add('reamaze-visible');
    });
});


